import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { TagSelector } from "../../../components/Taxonomy/TagSelector";
import { HorizontalStack, SmartContainer, Stack } from "../../../styles/Containers";
import { StyledButton } from "../../../styles/matieralui/Button";
import { StyledA, StyledH6, StyledP } from "../../../styles/StyledHTML";
import { IconPhotoLibrary } from "../../Icons";
import { createLibrary, searchLibrary } from "../Library/redux/library.actions";
import { FullLibraries } from "../Library/redux/library.selectors";
import { Screen } from "../Photostream/Uploader";
import { TERM_LIBRARY, TERM_LIBRARY_PLURAL } from "../../services/CaptureCollabService";
export const OnboardingLibraries = ({ type = null, onComplete, onBack }) => {
    const dispatch = useDispatch();
    const store = FullLibraries();
    const [items, setItems] = useState([]);

    const createTheLibrary = () => dispatch(createLibrary({ name: items[0]?.name }));
    useEffect(() => { if (store.createSuccess) onComplete(); }, [store.createLoading])
    useEffect(() => { dispatch(searchLibrary(0, null, null, 'all', {})) }, [])
    useEffect(() => { if (store?.items?.count > 0) onComplete(); }, [store])

    let heading = `Let's get started by creating your first ${TERM_LIBRARY}`;
    let description = `${TERM_LIBRARY_PLURAL} are the highest level of grouping assets. They are also how you grant permissions to other people to see their photos. It's best to setup a separate ${TERM_LIBRARY} for each group of people you want to access them.`;
    let examples = "Examples: By Business Location, By Client, By Campus";
    let label = `Enter the ${TERM_LIBRARY} Name`;

    // Church Content
    if (type == 'church') {
        heading = `Let's get started by creating your first ${TERM_LIBRARY}.`;
        description = `${TERM_LIBRARY_PLURAL} are the highest level of grouping assets. They are also how you grant permissions to other people to see their photos. For a church, a separate ${TERM_LIBRARY} for each campus is best.`;
        examples = "Examples: West Campus, East Campus, Main Campus, Global Branding, Women's Conference";
        label = "Campus Name"
    }

    return (
        <Screen>
            <Stack textAlign="center" maxWidth="600px">
                <StyledP><IconPhotoLibrary /></StyledP>
                <StyledH6>{heading}</StyledH6>
                <StyledP>{description}</StyledP>
                <br />
                <StyledP light>{examples}</StyledP>


                <TagSelector
                    noLabels={true}
                    inputLabel={label}
                    existingOptions={items}
                    options={store?.items?.rows}
                    onChange={(v) => setItems(v)}
                    limit={1}
                />


                <Stack width="100%" align="center" justify="center" thinking={store.createLoading}>
                    <StyledButton disabled={(items?.length < 1) ? true : false} variant="contained" color="blue" onClick={createTheLibrary}>Create Library</StyledButton>
                    <HorizontalStack flex align="center" justify="center">
                        <StyledP light small><StyledA onClick={onBack}>back</StyledA></StyledP>
                        <StyledP light small><StyledA onClick={onComplete}>skip</StyledA></StyledP>
                    </HorizontalStack>
                </Stack>

            </Stack>

        </Screen>
    )
}